import { axiosInstance } from "./config";

export default {
  state: {
    nearby_mini: {},
  },
  mutations: {
    Set_nearby_mini(state, payload) {
      state.nearby_mini = payload;
    },
    Set_update_nearby_mini(state, payload) {
      let nearby = state.nearby_mini.find((g) => g.id == payload.id)
      nearby.image = payload.image;
      nearby.name_en = payload.name_en;
      nearby.name_it = payload.name_it;
      nearby.name_ru = payload.name_ru;
      nearby.description_en = payload.description_en;
      nearby.description_it = payload.description_it;
      nearby.description_ru = payload.description_ru;
    },
  },
  actions: {
    async Get_nearby_mini({ commit }, payload) {
      if (!payload) {
        payload = "";
      } else {
        payload = "/" + payload;
      }
      return await axiosInstance
        .get(`/nearby_mini${payload}`)
        .then(function (data) {
          commit("Set_nearby_mini", data?.data?.data);
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
    async Post_nearby_mini(commit, payload) {
      return await axiosInstance
        .post("/nearby_mini/", payload)
        .then(function (data) {
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
    async Put_nearby_mini({ commit }, payload) {
      const formData = new FormData();
      formData.append("_method", "PUT");
      for (const key in payload) {
        if (
          Object.prototype.hasOwnProperty.call(payload, key) &&
          payload[key] !== undefined
        ) {
          formData.append(key, payload[key]);
        }
      }

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      return await axiosInstance
        .post("/nearby_mini/" + payload.id, formData, config)
        .then(function (data) {
          commit("Set_update_nearby_mini", data?.data?.data);
          return data?.data;
        })
        .catch(function (error) {
          return {
            error: error,
          };
        });
    },
    async Delete_nearby_mini(commit, payload) {
      return await axiosInstance
        .put("/nearby_mini/" + payload.id)
        .then(function (data) {
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
  },
  getters: {
    g_nearby_mini: (state) => state.nearby_mini,
  },
};
